import React, { ReactElement, useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useCheckRoutingInfoQueryCache } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { useParams } from "react-router-dom"
import { getJourneyFromParam } from "#/components/carrot-plans/hooks/useMedicalQuestionMenuItemWorkflow"

export default function WhatKindOfJourneyAfabDecisionStep(): ReactElement {
  const routingData = useCheckRoutingInfoQueryCache()
  const { journey: journeyParam } = useParams<{ journey: string }>()
  const journey = journeyParam ? getJourneyFromParam(journeyParam) : routingData?.journey
  const { send } = useStateMachine()

  useEffect(() => {
    send(journey)
  })
  return <></>
}
